import { render, staticRenderFns } from "./ScatterChart.vue?vue&type=template&id=5ac27aa8&scoped=true"
import script from "./ScatterChart.vue?vue&type=script&lang=ts"
export * from "./ScatterChart.vue?vue&type=script&lang=ts"
import style0 from "./ScatterChart.vue?vue&type=style&index=0&id=5ac27aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac27aa8",
  null
  
)

export default component.exports